import { AxiosMethods } from '../../../../enums';
import { ProductApi } from '../../../../enums/api/products';
import { axiosHelper } from '../../../axios-instance';

enum ProductsQueryKey {
  PRODUCT = 'product',
  REALTIME_INVENTORY = 'realtime-inventory'
}

interface GetProductQueryParams {
  productId: string;
}

export const getProductQuery = ({ productId }: GetProductQueryParams) => ({
  queryKey: [ProductsQueryKey.PRODUCT, productId],
  queryFn: () =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: ProductApi.getProduct.replace(':productId', productId),
      method: AxiosMethods.GET
    }),
  enabled: !!productId
});

interface GetProductLastSoldDetailsQueryParams {
  productId: string;
  accountId: string;
  addressId: string;
  limit?: number;
}

export const getProductLastSoldDetailsQuery = ({
  productId,
  accountId,
  addressId,
  limit = 10
}: GetProductLastSoldDetailsQueryParams) => ({
  queryKey: [ProductsQueryKey.PRODUCT, productId, accountId, addressId],
  queryFn: () =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: ProductApi.getProductLastSoldDetails,
      method: AxiosMethods.POST,
      data: {
        accountId,
        addressId,
        productId,
        limit
      }
    }),
  enabled: !!productId && !!accountId && !!addressId,
  staleTime: 10 * 60 * 1000,
  cacheTime: 10 * 60 * 1000
});

type GetRealtimeInventoryQueryParams = {
  productId: string;
};

export const getRealtimeInventoryQuery = ({
  productId
}: GetRealtimeInventoryQueryParams) => ({
  queryKey: [ProductsQueryKey.REALTIME_INVENTORY, productId],
  queryFn: () =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: ProductApi.realtimeInventory.replace(':productId', productId),
      method: AxiosMethods.GET
    }),
  enabled: !!productId
});
